"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var Arrows = function Arrows() {
  return /*#__PURE__*/_react["default"].createElement("svg", {
    className: "arrows",
    width: "10px",
    height: "18px",
    viewBox: "0 0 10 18",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "arrows",
    fill: "gray"
  }, /*#__PURE__*/_react["default"].createElement("polygon", {
    id: "up",
    points: "5 0 10 7.5 0 7.5"
  }), /*#__PURE__*/_react["default"].createElement("polygon", {
    id: "down",
    transform: "translate(5, 13.75) rotate(-180) translate(-5, -13.75) ",
    points: "5 10 10 17.5 0 17.5"
  })));
};

var MenuItem = function MenuItem(_ref) {
  var index = _ref.index,
      option = _ref.option,
      name = _ref.name,
      selected = _ref.selected,
      currentValue = _ref.currentValue,
      handleChange = _ref.handleChange;
  return /*#__PURE__*/_react["default"].createElement("button", {
    className: 'menu-item' + (selected ? ' selected' : ''),
    title: option.title,
    disabled: option.disabled,
    onClick: handleChange
  }, name);
};
/** SelectMenu */


var _default = function _default(_ref2) {
  var _ref2$options = _ref2.options,
      options = _ref2$options === void 0 ? [] : _ref2$options,
      value = _ref2.value,
      className = _ref2.className,
      customChild = _ref2.customChild,
      onChange = _ref2.onChange;

  var _useState = (0, _react.useState)(0),
      _useState2 = _slicedToArray(_useState, 2),
      isOpen = _useState2[0],
      setIsOpen = _useState2[1];

  var isStringArray = options && typeof options[0] === 'string';
  var ChildComponent = customChild || MenuItem;
  var currentName = isStringArray ? value : options[value] && options[value].name;

  var handleChangeAndClose = function handleChangeAndClose(value, index) {
    onChange(value, index);
    setIsOpen(false);
  };

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: 'select ' + (isOpen ? 'open ' : '') + (className || '')
  }, /*#__PURE__*/_react["default"].createElement("button", {
    className: "menu-closed",
    onClick: function onClick(value) {
      return setIsOpen(!isOpen);
    }
  }, currentName, /*#__PURE__*/_react["default"].createElement(Arrows, null)), /*#__PURE__*/_react["default"].createElement("div", {
    className: "menu-open"
  }, options && options.map(function (option, index) {
    return /*#__PURE__*/_react["default"].createElement(ChildComponent, {
      key: index,
      index: index,
      option: option,
      name: isStringArray ? option : option.name,
      currentValue: value,
      selected: (isStringArray ? option : option.value) === value,
      handleChange: function handleChange(event) {
        return handleChangeAndClose(isStringArray ? option : option.value, index);
      }
    });
  })));
};

exports["default"] = _default;